module.exports = __webpack_public_path__ + "static/media/star.1c2c5a73.svg";